import styled from '@emotion/styled';
import { spacing, borderRadius } from '@naf/theme';
import { Typography } from '@naf-simba/building-blocks-typography';
import { Tag } from '@naf-simba/elements-tag';
import { nafColor } from '@nafcore/theme';

export const ContextBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${spacing.space32};
  border-radius: ${borderRadius.L};
  border: 1px solid ${nafColor.neutral.neutral2};
  min-width: 0;
`;

export const VehicleBadge = styled(Tag)`
  position: absolute;
  top: -12px;
  left: ${spacing.space16};
`;

export const ContextTitle = styled(Typography)`
  && {
    margin: 0 0 ${spacing.space16};
  }
`;

export const ContextBody = styled.div`
  ul,
  ol {
    margin: 0 0 ${spacing.space16};
  }

  > *:last-child,
  p:last-child,
  ul:last-child,
  ol:last-child {
    margin-bottom: 0;
  }
`;

export const ContextCta = styled.div`
  margin-top: auto;
  padding-top: ${spacing.space24};
`;
